import type { ReactNode } from 'react'
import { useAuth } from './AuthProvider'
import { LoginScreen } from './LoginScreen'

interface Props {
  children: ReactNode
}

export function AuthGate({ children }: Props) {
  const { status } = useAuth()

  if (status === 'booting') {
    return <BootLoading />
  }
  if (status === 'unauthenticated') {
    return <LoginScreen />
  }
  return <>{children}</>
}

function BootLoading() {
  return (
    <div className="relative grid min-h-screen w-full place-items-center bg-bg-page text-text-soft">
      <div className="flex flex-col items-center gap-3 text-center">
        <div
          className="h-7 w-7 animate-spin rounded-full border-2 border-white/10 border-t-violet"
          aria-hidden="true"
        />
        <p className="m-0 text-[12.5px] text-text-mute">
          Verificando sessão…
        </p>
      </div>
    </div>
  )
}
